import { useQuery } from '@tanstack/react-query'

import type {
  GetCountryByCodeResponse,
  SearchCountriesResponse,
  SearchNationalitiesResponse,
} from '../types/nationality.js'

import { apiClient } from '../lib/client.js'

export const useSearchNationalitiesQuery = ({ search }: { search: string }) =>
  useQuery<SearchNationalitiesResponse>({
    enabled: search.length > 0,
    queryFn: async () => {
      const response = await apiClient.client.get<SearchNationalitiesResponse>(
        `/nationality/search`,
        { params: { q: search } }
      )
      return response.data
    },
    queryKey: ['nationalities', 'search', search],
  })

export const useSearchCountriesQuery = ({ search }: { search: string }) =>
  useQuery<SearchCountriesResponse>({
    enabled: search.length > 0,
    queryFn: async () => {
      const response = await apiClient.client.get<SearchCountriesResponse>(
        `/nationality/search-by-country`,
        { params: { q: search } }
      )
      return response.data
    },
    queryKey: ['countries', 'search', search],
  })

export const useGetCountryByCodeQuery = ({ code }: { code: null | string }) =>
  useQuery<GetCountryByCodeResponse>({
    enabled: !!code && code.length > 0,
    queryFn: async () => {
      const response = await apiClient.client.get<GetCountryByCodeResponse>(
        `/nationality/country-by-code`,
        { params: { code } }
      )
      return response.data
    },
    queryKey: ['countries', 'by-code', code],
    staleTime: Infinity,
  })
